'use client';

import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { byAppVariant } from '@/consts/AppVariants';
import mainPictureDesktopChristmas from '@/public/assets/image/purchase_banner/christmas/main-picture-desktop.webp';
import mainPictureMobileChristmas from '@/public/assets/image/purchase_banner/christmas/main-picture-mobile.webp';
import mainPictureDesktopBase from '@/public/assets/image/purchase_banner/default/main-picture-desktop.webp';
import mainPictureMobileBase from '@/public/assets/image/purchase_banner/default/main-picture-mobile.webp';
import mainPictureTabletBase from '@/public/assets/image/purchase_banner/default/main-picture-tablet.webp';

const InfoBanner = () => {
  const t = useTranslations('lobby.info-banner');
  const mainPictureDesktop = byAppVariant({
    christmas: mainPictureDesktopChristmas,
    default: mainPictureDesktopBase,
  });
  const mainPictureMobile = byAppVariant({
    christmas: mainPictureMobileChristmas,
    default: mainPictureMobileBase,
  });
  const mainPictureTablet = byAppVariant({
    christmas: mainPictureTabletBase,
    default: mainPictureTabletBase,
  });

  const commonImageProps = {
    alt: 'main-picture',
    quality: 100 as const,
    loading: 'lazy' as const,
  };

  return (
    <div
      className="flex flex-col md:flex-row items-center justify-center mt-4.75 lg:-mt-0.5 mb-6 md:mb-5 rounded-2xl
             bg-background-gradient relative overflow-hidden"
    >

      <div className="w-full md:w-71 h-53.25 md:h-39.5 flex justify-center rounded-2xl overflow-hidden relative order-1 md:order-1 shrink-0">
        <div className="absolute -top-[19%] md:top-0 flex items-center justify-center z-1">
          <Image
            src={mainPictureMobile}
            alt={commonImageProps.alt}
            quality={commonImageProps.quality}
            loading={commonImageProps.loading}
            className="w-95 h-72.5 object-cover min-[31.25rem]:hidden md:hidden"
          />
          <Image
            src={mainPictureTablet}
            alt={commonImageProps.alt}
            quality={commonImageProps.quality}
            loading={commonImageProps.loading}
            className="hidden min-[31.25rem]:block md:hidden! w-full h-72.5 object-cover"
          />
          <Image
            src={mainPictureDesktop}
            alt={commonImageProps.alt}
            quality={commonImageProps.quality}
            loading={commonImageProps.loading}
            className="hidden md:block w-71 h-39.5 object-cover object-center"
          />
        </div>
        <div
          className="
          absolute size-full
          -right-[29%] -bottom-[49%] rotate-20
          bg-[linear-gradient(112deg,#4C2959_22.67%,#BD4DF9_41.22%,#FE5104_73.46%)]
          blur-[3.75rem]
          md:w-full
          md:-right-[29%]
          md:rotate-20
        "
        >
        </div>
      </div>

      <div className="flex flex-col items-center md:items-start md:flex-1 order-2 md:order-2 px-4 pt-2.5 pb-6 md:py-2 md:justify-center lg:justify-start md:px-4 lg:pt-7 lg:pl-6 md:min-h-39.5 md:p-0">
        <h2 className="w-full flex justify-start items-center font-medium text-[1.75rem] md:mt-0 lg:text-[2rem] tracking-[-0.06em] text-gradient bg-promo-banner-title-gradient ">
          {t('title')}
        </h2>
        <p className="text-primary-3 flex justify-center md:justify-start items-center font-regular text-[0.875rem] leading-5 mt-1  md:mt-1.5 lg:mt-1.5">
          {t.rich('description', {
            br: () => <br className="hidden xl:block" />,
          })}
        </p>
      </div>

    </div>

  );
};

export default InfoBanner;
